module.exports = __webpack_public_path__ + "img/arr-down.d1c98714.svg";